import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { OtifTrendsService } from "./service/otif-trends.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
addMore(Highcharts);
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Params } from "@angular/router";
import { CommonService } from "../../../../shared/services";
@Component({
  selector: "widget-otif-trends",
  templateUrl: "./widget-otif-trends.component.html",
  styleUrls: ["./widget-otif-trends.component.scss"],
  providers: [OtifTrendsService]
})
export class WidgetOtifTrendsComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() FILTERS;
  @Input() OPTIONS;

  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  ErrMsg = "";
  mockChart = null;
  private unsubscribe: Subject<void> = new Subject();
  constructor(
    private translateService: TranslateService,
    private dataService: OtifTrendsService,
    private commonService: CommonService,
    private activateRoute: ActivatedRoute
  ) { }

  ngAfterViewInit() {
   
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      
    }
  }

  ngOnInit() {
    const intiFilter = JSON.parse(JSON.stringify(this.FILTERS))
    this.translateService
      .get("WAREHOUSE.WAREHOUSE_SLA_TREND")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
      this.activateRoute.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((params: Params) => {
        if (Object.keys(params).length) {
          this.FILTERS = this.commonService.getFiltersParams(params, this.FILTERS);
          this.getOTIFTrendData();
        } else {
          this.FILTERS=JSON.parse(JSON.stringify(intiFilter));
          this.getOTIFTrendData();
        }
      })
  }

  getOTIFTrendData() {
    this.chartOptions = null;
    this.mockChart = null;
    this.ErrMsg = "";
    this.dataService.getOTIFTrendData(this.OPTIONS.api, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          if (chartData === null) {
            this.ErrMsg = "ERROR_MSG.NO_DATA";
            this.mockChart = HSET.chartData;
          } else {
            this.chartOptions = this.dataService.createChart(
              chartData,
              this.OPTIONS
            );
          }
        },
        err => {
          this.ErrMsg = "ERROR_MSG.SYSTEM_ERROR";
          this.mockChart = HSET.chartData;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
